/**
 * Horographia — 브랜드별 역사 · 강점 (교육용).
 */

export type BrandMilestone = {
  year: string;
  titleKo: string;
  body: string;
};

export type BrandProfile = {
  brandId: string;
  hq: string;
  groupNote: string;
  history: string[];
  strengths: string[];
  character: string;
  milestones: BrandMilestone[];
  watchOut: string;
};

export const brandProfiles: BrandProfile[] = [
  {
    brandId: 'rolex',
    hq: '제네바 · 스위스',
    groupNote: '독립 기업으로 자주 소개됨 (한스 빌스도르프 재단 계열로 알려짐).',
    history: [
      '1905년 런던에서 한스 빌스도르프가 시계 유통을 시작했고, 이후 제네바로 기반을 옮겼다.',
      '오이스터 방수 케이스(1920년대)와 퍼페추얼 오토매틱이 「도구를 일상에」 심는 서사의 축이 되었다.',
      '서브마리너·GMT·데이토나 등 스포츠 라인이 20세기 후반 대중 문화와 강하게 결합했다.',
    ],
    strengths: [
      '방수·내구를 전제로 한 스포츠 케이스 전통',
      '라인업 일관성 (서브·GMT·DJ·데이토나)',
      '서비스 네트워크와 브랜드 인지도',
      '자체 칼리버·생산 수직 통합 이미지',
    ],
    character: '도구 워치의 상징을 럭셔리 스포츠로 고정한 브랜드. 「시세」와 「정가」가 자주 어긋나는 시장 현상으로도 이야기된다.',
    milestones: [
      { year: '1905', titleKo: '창업', body: '런던에서 Wilsdorf & Davis로 출발.' },
      { year: '1926', titleKo: '오이스터', body: '스크류 구조 방수 케이스가 상징이 됨.' },
      { year: '1945', titleKo: '데이트저스트', body: '항상 보이는 날짜 창의 대중화.' },
      { year: '1953', titleKo: '서브마리너', body: '다이빙 도구 아이콘의 시작.' },
      { year: '1963', titleKo: '데이토나', body: '타키미터 크로노그래프 라인.' },
    ],
    watchOut: '교육용 요약이며 시세·진품·투자 조언이 아닙니다. 현행 사양은 세대마다 다릅니다.',
  },
  {
    brandId: 'omega',
    hq: '비엔 · 스위스',
    groupNote: '스와치 그룹(Swatch Group) 산하.',
    history: [
      '1848년 루이 브란트가 라쇼드퐁에서 조립을 시작했고, 이후 오메가 브랜드로 성장했다.',
      '올림픽 공식 타임키퍼 이력과 스피드마스터의 우주 비행 기록이 20세기 이미지를 크게 만들었다.',
      '2000년대 이후 코액시얼 이스케이프먼트를 양산 라인에 넓히며 기술 차별을 강조해 왔다.',
    ],
    strengths: [
      '크로노그래프·다이버 양쪽 포트폴리오',
      '코액시얼 등 기구 혁신 스토리',
      '미션·스포츠 타임키핑 유산',
      '스와치 그룹 생산·유통 인프라',
    ],
    character: '우주·스포츠·다이빙을 아우르는 「이야기 있는 툴」과 현대 기술(코액시얼)을 함께 파는 메이커.',
    milestones: [
      { year: '1848', titleKo: '기원', body: '브란트 가문의 시계 사업 시작.' },
      { year: '1957', titleKo: '스피드마스터', body: '이후 달 착륙 미션과 연결되는 크로노.' },
      { year: '1948', titleKo: '심마스터', body: '다이빙·트래블 패밀리의 뿌리.' },
      { year: '1999~', titleKo: '코액시얼', body: '대니얼스 설계를 양산 채택.' },
    ],
    watchOut: 'NASA 관련 서사는 특정 모델·시대에 한정됩니다. 교육용입니다.',
  },
  {
    brandId: 'patek',
    hq: '제네바 · 스위스',
    groupNote: '독립 하이엔드 매뉴팩처로 자주 분류됨 (스턴 가문).',
    history: [
      '1839년 안토니 파텍과 프랑수아 차페크가 제네바에서 출발했고, 이후 아드리앙 필립이 합류했다.',
      '회중시계 시대부터 컴플리케이션과 마감으로 「기준점」 이미지를 쌓았다.',
      '1976년 노틸러스(제라드 제엔타)로 강철 스포츠 럭셔리 축을 열었고, 칼라트라바는 드레스의 전형으로 남았다.',
    ],
    strengths: [
      '그랜드 컴플리케이션·마감 전통',
      '칼라트라바 드레스 비례',
      '노틸러스 스포츠 럭셔리 위상',
      '장기 보유·가문 계승 마케팅',
    ],
    character: '하이엔드 「기준」으로 자주 인용되지만, 시세 왜곡과 접근성 논의도 함께 따라온다.',
    milestones: [
      { year: '1839', titleKo: '창업', body: '제네바 매뉴팩처의 시작.' },
      { year: '1932', titleKo: '칼라트라바', body: '라운드 드레스 라인.' },
      { year: '1976', titleKo: '노틸러스', body: '포르톨 케이스 스포츠 럭셔리.' },
    ],
    watchOut: '정가와 중고·그레이 시세 괴리가 클 수 있습니다. 감정이 아닙니다.',
  },
  {
    brandId: 'ap',
    hq: '르브라쥐 · 스위스',
    groupNote: '리슈몽(Richemont) 그룹.',
    history: [
      '1875년 쥘 루이 오데마르와 에드워드 오귀스트 피게가 르브라쥐에서 설립했다.',
      '복잡 회중·손목 컴플리케이션으로 하이엔드를 지키다가, 1972년 로열 오크로 강철 스포츠의 문법을 바꿨다.',
      '옥타곤 베젤·노출 스크류·탭isserie는 이후 수많은 「통합 브레이슬릿 스포츠」에 영향을 주었다.',
    ],
    strengths: [
      '로열 오크 디자인 언어의 원형',
      '르브라쥐 매뉴팩처·마감',
      '오프쇼어 등 사이즈·소재 확장',
      '스포츠 럭셔리 문화적 위상',
    ],
    character: '「강철도 하이엔드」를 증명한 상징. 케이스·브레이슬릿 마감 이야기가 많다.',
    milestones: [
      { year: '1875', titleKo: '창업', body: '르브라쥐 매뉴팩처.' },
      { year: '1972', titleKo: '로열 오크', body: '제엔타 디자인, 옥타곤 베젤.' },
      { year: '1993', titleKo: '오프쇼어', body: '더 큰 스포츠 파생.' },
    ],
    watchOut: '교육용 요약. 현행 레퍼런스는 세대별로 다릅니다.',
  },
  {
    brandId: 'cartier',
    hq: '파리 · 프랑스 / 시계는 스위스 생산 비중 큼',
    groupNote: '리슈몽(Richemont) 그룹.',
    history: [
      '1847년 루이프랑수아 까르띠에가 파리에서 주얼리 공방을 열었다.',
      '산토스(초기 파일럿용 손목시계로 언급)·탱크 등 기하 케이스로 「형태가 먼저인 시계」를 제시했다.',
      '주얼리 하우스로서의 미학과 스위스 매뉴팩처 기계식을 병행한다.',
    ],
    strengths: [
      '아이코닉 케이스 실루엣 (탱크·산토스)',
      '주얼리·메탈 마감 감각',
      '쿼츠부터 하이엔드 기계식까지 폭',
      '디자인 우선의 브랜드 정체성',
    ],
    character: '호롤로지 「기구」보다 「형태·장식」이 먼저 읽히는 하우스. 그래서 드레스·패션 맥락과 잘 붙는다.',
    milestones: [
      { year: '1847', titleKo: '창업', body: '파리 주얼리.' },
      { year: '1904', titleKo: '산토스', body: '초기 손목시계 서사.' },
      { year: '1917~19', titleKo: '탱크', body: '직사각 아이콘.' },
    ],
    watchOut: '모델에 따라 쿼츠·기계식 성격이 크게 다릅니다.',
  },
  {
    brandId: 'seiko',
    hq: '도쿄 · 일본',
    groupNote: '세이코 그룹. 그랜드 세이코는 별도 브랜드로 분리·강조되는 경우가 많음.',
    history: [
      '1881년 곤도 긴자로가 시계점을 연 것이 기원으로 소개된다.',
      '1969년 쿼츠 아스트론으로 산업을 흔들었고, 이후 스프링드라이브·그랜드 세이코로 「정밀의 다른 길」을 보여 주었다.',
      '프로스펙스 등 다이버·필드 툴은 접근성 있는 도구 라인으로 사랑받는다.',
    ],
    strengths: [
      '쿼츠·스프링드라이브·하이비트 등 기술 폭',
      '다이버·필드 툴의 가성비',
      '그랜드 세이코급 마감·조율',
      '일본 매뉴팩처 서사',
    ],
    character: '「스위스만의 이야기」가 아닌 축. 엔트리 툴부터 하이엔드 조율까지 한 지붕 아래 스펙트럼이 넓다.',
    milestones: [
      { year: '1881', titleKo: '기원', body: '도쿄 시계점.' },
      { year: '1969', titleKo: '아스트론', body: '쿼츠 손목시계 상용화.' },
      { year: '1999~', titleKo: '스프링드라이브', body: '태엽+전자 제어.' },
    ],
    watchOut: '그랜드 세이코와 세이코 본 라인은 등급·가격대가 다릅니다.',
  },
  {
    brandId: 'jlc',
    hq: '르상티에(발레드주) · 스위스',
    groupNote: '리슈몽(Richemont) 그룹.',
    history: [
      '1833년 앙투안 르쿨트르가 발레드주에 공방을 열었다. 이후 예거와 결합하며 브랜드명이 굳어졌다.',
      '리버소(1931)의 플립 케이스는 폴로·아르데코와 함께 롱런 아이콘이 되었다.',
      '메모복스 알람, 초박·컴플리케이션 칼리버 공급 역사로 「매뉴팩처의 매뉴팩처」로 불리기도 한다.',
    ],
    strengths: [
      '리버소 플립 케이스',
      '자체 칼리버·초박·알람 기구',
      '발레드주 매뉴팩처 집중',
      '디자인·기술 균형',
    ],
    character: '기구 창의와 아르데코 미학이 동시에 강한 브랜드.',
    milestones: [
      { year: '1833', titleKo: '창업', body: '발레드주.' },
      { year: '1931', titleKo: '리버소', body: '뒤집히는 케이스.' },
      { year: '1950', titleKo: '메모복스', body: '알람 손목시계 상징.' },
    ],
    watchOut: '교육용 요약입니다.',
  },
  {
    brandId: 'iwc',
    hq: '샤프하우젠 · 스위스',
    groupNote: '리슈몽(Richemont) 그룹.',
    history: [
      '1868년 미국인 플로렌타인 아리오스토 존스가 샤프하우젠에 설립. 「미국식 생산 + 스위스 정밀」 서사가 초기에 있었다.',
      '파일럿 워치는 장갑 조작·가독성을 전제로 한 도구 전통을 쌓았다.',
      '포르투기저는 큰 다이얼·철도 눈금의 클래식으로, 장파워·크로노 등으로 확장된다.',
    ],
    strengths: [
      '파일럿 가독성·양파 크라운',
      '포르투기저 클래식 비례',
      '장파워 리저브 칼리버',
      '도구적·남성적 이미지 (마케팅)',
    ],
    character: '리슈몽 안에서 「엔지니어링·항공」 톤이 뚜렷한 하우스.',
    milestones: [
      { year: '1868', titleKo: '창업', body: '샤프하우젠.' },
      { year: '1936~', titleKo: '파일럿', body: '항공 시계 전통.' },
      { year: '1939', titleKo: '포르투기저 기원', body: '큰 다이얼 클래식.' },
    ],
    watchOut: '빅 파일럿 등 대형 모델은 착용감이 크게 다릅니다.',
  },
  {
    brandId: 'vc',
    hq: '제네바 · 스위스',
    groupNote: '리슈몽(Richemont) 그룹. 「3대 하이엔드」로 파텍·AP와 함께 묶이곤 함.',
    history: [
      '1755년 장마르크 바쉐론이 제네바에서 창업. 현존 최장수 시계 매뉴팩처 중 하나로 소개된다.',
      '장식 마감·슬림 드레스·메티에 다르(수공예 다이얼) 전통이 강하다.',
      '1996년 오버시즈로 스포츠 럭셔리에 본격 진입했고, 말테 크로스 모티브가 시그니처다.',
    ],
    strengths: [
      '장수 매뉴팩처 유산',
      '마감·메티에 다르',
      '오버시즈 스포츠 라인',
      '슬림 드레스·트래디션넬',
    ],
    character: '화려함보다 「정제된 하이엔드」 톤. 오버시즈로 스포츠 축을 보강했다.',
    milestones: [
      { year: '1755', titleKo: '창업', body: '제네바.' },
      { year: '1880', titleKo: '말테 크로스', body: '브랜드 상징으로 정착.' },
      { year: '1996', titleKo: '오버시즈', body: '스포츠 럭셔리.' },
    ],
    watchOut: '교육용 요약. 시세·감정이 아닙니다.',
  },
  {
    brandId: 'longines',
    hq: '생티미에 · 스위스',
    groupNote: '스와치 그룹. 윙드 아워글래스 로고로 유명.',
    history: [
      '1832년 오귀스트 아가시 등이 시작한 사업이 론진으로 이어졌다.',
      '항공·스포츠 계측(타임키핑) 역사로 「기록의 시계」 이미지를 쌓았다.',
      '현대에는 하이드로콘퀘스트·마스터·스피릿 등으로 접근성 있는 스위스 기계식을 넓힌다.',
    ],
    strengths: [
      '스포츠·항공 타임키핑 유산',
      '가격 대비 마감·완성도',
      '클래식·다이버 라인 균형',
      '스와치 그룹 안정성',
    ],
    character: '하이엔드 「신화」보다 「사서 차는 스위스」에 가깝다. 입문·중급에서 자주 추천된다.',
    milestones: [
      { year: '1832', titleKo: '기원', body: '생티미에 일대.' },
      { year: '20세기', titleKo: '스포츠 계측', body: '대회·항공 타이밍.' },
      { year: '2007', titleKo: '하이드로콘퀘스트', body: '현대 다이버 라인.' },
    ],
    watchOut: '교육용. 모델별 방수·사양은 매뉴얼을 따릅니다.',
  },
];

export function brandProfileById(brandId: string): BrandProfile | undefined {
  return brandProfiles.find((b) => b.brandId === brandId);
}
